/**
 * US Map Configuration Overrides
 * Sets the correct container div and disables popups/URLs
 */

// Override main settings
simplemaps_usmap_mapdata.main_settings.div = "usmap";
simplemaps_usmap_mapdata.main_settings.auto_load = "yes";
simplemaps_usmap_mapdata.main_settings.popups = "off";
simplemaps_usmap_mapdata.main_settings.state_url = "";

// Brand colors
simplemaps_usmap_mapdata.main_settings.background_color = MAP_COLORS.background;
simplemaps_usmap_mapdata.main_settings.background_transparent = "no";
simplemaps_usmap_mapdata.main_settings.state_color = MAP_COLORS.stoneDefault;
simplemaps_usmap_mapdata.main_settings.state_hover_color = MAP_COLORS.goldHover;
simplemaps_usmap_mapdata.main_settings.border_color = MAP_COLORS.border;
simplemaps_usmap_mapdata.main_settings.label_color = MAP_COLORS.label;
simplemaps_usmap_mapdata.main_settings.label_hover_color = MAP_COLORS.labelHover;
simplemaps_usmap_mapdata.main_settings.label_size = 18;
simplemaps_usmap_mapdata.main_settings.all_locations_hidden = "yes";  // Hide location markers
simplemaps_usmap_mapdata.main_settings.manual_zoom = "no";  // Disable manual zoom
simplemaps_usmap_mapdata.main_settings.keyboard_navigation = "no";  // Disable keyboard navigation completely

// Zoom/position settings to center map in 4:3 container
simplemaps_usmap_mapdata.main_settings.initial_zoom = -1;  // Fit to container

// Set all states to have no URL (we handle clicks ourselves)
for (var state in simplemaps_usmap_mapdata.state_specific) {
  simplemaps_usmap_mapdata.state_specific[state].url = "";
}
